module.exports = __webpack_public_path__ + "4e9fa2864b092ad5b5f32f8f85ad035e.png";